import React from 'react';
import './App.css';
import './i18n/config';  // Initialize i18n
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import LandingPage from './pages/LandingPage';
import CaseStudyPage from './pages/CaseStudyPage';
import LegalPage from './pages/LegalPage';
import NotFoundPage from './pages/NotFoundPage';
import MatrixBackground from './components/MatrixBackground';
import CodeLines from './components/CodeLines';
import TechParticles from './components/TechParticles';
import { Toaster } from './components/ui/toaster';
import { RootRedirect, LangLayout } from './seo/LangRouting';
import { LANDING_PAGES, LEGAL_PAGES } from './seo/seoConfig';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* Animated backgrounds - subtle */}
        <MatrixBackground opacity={0.15} />
        <CodeLines />
        <TechParticles />
        
        {/* Main content */}
        <div className="relative z-10">
          <Navbar />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/404" element={<NotFoundPage />} />
            {Object.values(LANDING_PAGES).flatMap((page) => Object.entries(page.slugs).map(([lang, slug]) => (
              <Route key={`short-${slug}`} path={`/${slug}`} element={<Navigate to={`/${lang}/${slug}`} replace />} />
            )))}
            <Route path="/:lang" element={<LangLayout />}>
              <Route index element={<Home />} />
              {Object.entries(LANDING_PAGES).flatMap(([key, page]) => Object.values(page.slugs).map((slug) => (
                <Route key={slug} path={slug} element={<LandingPage pageKey={key} />} />
              )))}
              {Object.entries(LEGAL_PAGES).flatMap(([key, page]) => Object.values(page.slugs).map((slug) => (
                <Route key={slug} path={slug} element={<LegalPage pageKey={key} />} />
              )))}
              <Route path=":segment/:slug" element={<CaseStudyPage />} />
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Route>
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
          <Footer />
          <Toaster />
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
